module.exports = __webpack_public_path__ + "img/GAME_DICTATION.0ca2df54.png";